<template>
  <div class="PreferenciasServentia">
    <div class="PreferenciasServentia_header">
      Importação de registros
    </div>
    <div class="row p-2">
      <div class="col-3">
        <label for="migrar_registros_crc"
               class="label">
          Importar registros da CRC
        </label>
        <div class="col-8 m-0 p-0">
          <select id="migrar_registros_crc"
                  v-model="migrar_registros_crc"
                  v-validate="'required'"
                  class="custom-select custom-select-sm"
                  name="migrar_registros_crc"
                  :disabled="migracao_status && migracao_status !== 'IN_QUEUE'"
                  @change="update('MIGRAR_REGISTROS_CRC', migrar_registros_crc)">
            <option v-for="(value, index) in opcoesImportarRegistrosCRC"
                    :key="index"
                    :value="value">
              {{ value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 mt-1">
        <small class="text-danger"><i>Ao marcar esta opção seu cartório entra na fila para importação de registros da CRC</i></small>
      </div>
    </div>
  </div>
</template>

<script>
  /* Services */
  import CartorioConfigService from '@/services/CartorioConfigService'
  import MigracaoService from "@/services/MigracaoService"

  /* Getters */
  import { mapGetters } from 'vuex'

  export default {
    name: 'PreferenciasServentia',
    data () {
      return {
        migrar_registros_crc: 'Não',
        migracao_status: null,
        opcoesImportarRegistrosCRC: [
          'Sim',
          'Não'
        ]
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    async beforeMount () {
      // Importar Registros CRC //
      const migracao = await MigracaoService.getMigracaoByCartorio(this.cartorioId)

      if (migracao) this.migracao_status = migracao.status

      const configMigrarRegistrosCRC = await CartorioConfigService.showByChave({
        chave: 'MIGRAR_REGISTROS_CRC'
      })

      if (configMigrarRegistrosCRC.valor) {
        this.migrar_registros_crc = configMigrarRegistrosCRC.valor
      }
    },
    methods: {
      async update (chave, valor) {
        await CartorioConfigService.updateByChave({ chave, valor })
      }
    }
  }
</script>

<style lang="scss">
  .PreferenciasServentia {
    &_header {
      background: #eaeaea;
      color: #000;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 0px;
    }
  }
</style>
